module.exports = "module.exports = __webpack_public_path__ + \"static/media/header.0743929f.template\";"